/**
 * 日期工具函数
 */

/**
 * 格式化日期为本地字符串
 * 
 * @param {string|Date} date - 日期字符串或Date对象
 * @param {Object} options - 格式化选项
 * @param {boolean} options.showTime - 是否显示时间，默认为false
 * @param {boolean} options.showYear - 是否显示年份，默认为true
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, options = {}) => {
  if (!date) return '未知日期';
  
  const { showTime = false, showYear = true } = options;
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (isNaN(dateObj.getTime())) {
      return '无效日期';
    }
    
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    
    // 补零函数
    const padZero = (num) => num.toString().padStart(2, '0');
    
    let formattedDate = `${month}月${day}日`;
    
    if (showYear) {
      formattedDate = `${year}年${formattedDate}`;
    }
    
    if (showTime) {
      formattedDate += ` ${padZero(hours)}:${padZero(minutes)}`;
    }
    
    return formattedDate;
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '日期错误';
  }
};

/**
 * 获取相对时间描述（如：3天前，刚刚等）
 * 
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 相对时间描述
 */
export const getRelativeTime = (date) => {
  if (!date) return '';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (isNaN(dateObj.getTime())) {
      return '无效日期';
    }
    
    const now = new Date();
    const diffMs = now - dateObj;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    const diffMonth = Math.floor(diffDay / 30);
    const diffYear = Math.floor(diffMonth / 12);
    
    if (diffSec < 60) {
      return '刚刚';
    } else if (diffMin < 60) {
      return `${diffMin}分钟前`;
    } else if (diffHour < 24) {
      return `${diffHour}小时前`;
    } else if (diffDay < 30) {
      return `${diffDay}天前`;
    } else if (diffMonth < 12) {
      return `${diffMonth}个月前`;
    } else {
      return `${diffYear}年前`;
    }
  } catch (error) {
    console.error('相对时间计算错误:', error);
    return '';
  }
}; 